import {isDevQuan} from "@Common/ui-components/debug/is-dev-quan";

import {loadDevApis}  from "./dev-apis";
import {loadLiveApis} from "./live-apis";

export const loadApis = isDevQuan() ? loadDevApis : loadLiveApis;
